import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.25 5.375C4.25 4.75625 3.74375 4.25 3.125 4.25C2.50625 4.25 2 4.75625 2 5.375V30.125C2 33.2328 4.51719 35.75 7.625 35.75H36.875C37.4938 35.75 38 35.2437 38 34.625C38 34.0063 37.4938 33.5 36.875 33.5H7.625C5.76172 33.5 4.25 31.9883 4.25 30.125V5.375ZM35.4195 12.9195C35.8555 12.4836 35.8555 11.7664 35.4195 11.3305C34.9836 10.8945 34.2664 10.8945 33.8305 11.3305L24.5 20.6609L18.5445 14.7055C18.1086 14.2695 17.3914 14.2695 16.9555 14.7055L9.08047 22.5805C8.64453 23.0164 8.64453 23.7336 9.08047 24.1695C9.51641 24.6055 10.2336 24.6055 10.6695 24.1695L17.75 17.0891L23.7055 23.0445C24.1414 23.4805 24.8586 23.4805 25.2945 23.0445L35.4195 12.9195Z" })
});
export default SvgChartLine;
